import { envType, perimeterType } from './analyticsWebTypes';
const PROD_HOST = 'as.atlassian.com/api/v1';
const STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const FEDRAMP_SANDBOX_HOST = 'as.atlassian-fex.com/api/v1';
const STARGATE_FEDRAMP_SANDBOX_HOST = 'api-private.atlassian-fex.com/gasv3/api/v1';
const STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const handleFedRampModerate = ({
  useStargate,
  env,
  useLegacyUrl
}) => {
  if (env === envType.PROD) {
    throw new Error('FedRAMP Moderate prod destination not yet set');
  }
  if (!useStargate) {
    return FEDRAMP_SANDBOX_HOST;
  }
  if (useLegacyUrl) {
    return STARGATE_FEDRAMP_SANDBOX_HOST;
  }

  /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */
  return window.location.host + STARGATE_PROXY_PATH;
};
const handleCommercial = ({
  useStargate,
  env,
  useLegacyUrl
}) => {
  if (!useStargate) {
    return env === envType.PROD ? PROD_HOST : STAGING_HOST;
  }
  if (useLegacyUrl) {
    return env === envType.PROD ? STARGATE_PROD_HOST : STARGATE_STAGING_HOST;
  }

  /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */
  return window.location.host + STARGATE_PROXY_PATH;
};
export function selectHost({
  useStargate,
  env,
  useLegacyUrl,
  perimeter
}) {
  if (perimeter === perimeterType.FEDRAMP_MODERATE) {
    return handleFedRampModerate({
      useStargate,
      env,
      useLegacyUrl
    });
  }
  return handleCommercial({
    useStargate,
    env,
    useLegacyUrl
  });
}